import { render } from "./t-shirt.vue?vue&type=template&id=5d6b8d24"
import script from "./t-shirt.vue?vue&type=script&lang=js"
export * from "./t-shirt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__